import { Screen } from '@/shared/ui/Layout'

import { FeedExperience } from '../ui/FeedExperience'

export const FeedPage = ({ focusPostId = undefined, openComments = false } = {}) => (
  <Screen>
    <FeedExperience focusPostId={focusPostId} openComments={openComments} />
  </Screen>
)
